import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { useAppSelector } from '@/store/hooks';

import {
  SNACKBAR_DURATION_MAPPER,
  SNACKBAR_SUCCESS_DURATION_TIME,
  SNACKBAR_TYPE,
} from './Snackbar.constants';
import { SnackbarPayload, SnackbarState } from './Snackbar.types';

export const initialState: SnackbarState = {
  closeCallback: null,
  duration: SNACKBAR_SUCCESS_DURATION_TIME,
  message: null,
  open: false,
  type: null,
};

const snackbarSlice = createSlice({
  initialState,
  name: 'snackbar',
  reducers: {
    RESET: () => initialState,
    SET_SNACKBAR_DATA: (state, action: PayloadAction<SnackbarPayload>) => {
      const {
        duration,
        message,
        type = SNACKBAR_TYPE.SUCCESS,
      } = action.payload;

      state.open = true;
      state.message = message;
      state.type = type;
      state.duration = duration ?? SNACKBAR_DURATION_MAPPER[type];
      state.closeCallback = action.payload.closeCallback || null;
    },
  },
});

export const snackbarReducer = snackbarSlice.reducer;
export const snackbarActions = snackbarSlice.actions;

export const useSnackbarSelector = () => {
  return useAppSelector((state) => state.snackbar);
};
